export const TwitterIcon = ({ size = 14, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11.0833 0.583374H13.25L8.53333 6.00004L14 13.4167H9.73333L6.32667 8.95337L2.42 13.4167H0.252L5.28667 7.62671L0 0.584041H4.37333L7.46333 4.68004L11.0833 0.583374ZM10.3267 12.0867H11.5067L3.72 1.79337H2.44667L10.3267 12.0867Z"
      fill="#AAB3D0"
    />
  </svg>
);
